import "./polyfill";
import { StrictMode } from "react";
import { createReactRoot } from "common/react/create-react-root";
import { parseDataConfig } from "common/utils/parse-data-config";
import { App } from "@design-lab/app";
import type { DesignLabConfig } from "@design-lab/shared/lib/config";

function init() {
  let container = document.querySelector(".js-design-lab");

  if (!container) {
    container = document.createElement("div");
    document.body.appendChild(container);
  }

  // Read config from data attribute
  const configData = container.getAttribute("data-config");
  const config = parseDataConfig(configData) as DesignLabConfig;

  createReactRoot(container, "Design Lab").render(
    <StrictMode>
      <App config={config} />
    </StrictMode>
  );
}

document.addEventListener("DOMContentLoaded", () => {
  init();
});
